import reduce from 'lodash/reduce'
import map from 'lodash/map'
import {extractQueryParams} from '@frontrow/console/src/entities/helpers/routers/query-params'

import {
  type FetchDataParamsT,
  type FilterT
} from '@frontrow/console/src/components/common/data-table'

export function createDatatableUrl(
  baseUrl: string,
  fetchDataParams?: FetchDataParamsT | null
): string {
  if (fetchDataParams === null || fetchDataParams === undefined) {
    return baseUrl
  } else {
    const {filters} = fetchDataParams

    const urlParamsForFilter = reduce(
      filters,
      (acc, {id, value}) => {
        const urlKey = id
        const urlValue =
          value !== null && value !== undefined && value.length !== 0
            ? encodeURIComponent(value)
            : null
        const keyValUrl =
          urlValue !== null && urlValue !== undefined && urlValue.length !== 0
            ? `${urlKey}=${urlValue}`
            : ''
        return acc.length === 0 ? `?${keyValUrl}` : `${acc}&${keyValUrl}`
      },
      ''
    )
    return `${baseUrl}${urlParamsForFilter}`
  }
}

export function parseFilterUrl(location: {search: string}): Array<FilterT> {
  const params = extractQueryParams(location)
  if (params) {
    return parseFiltersFromQueryParams(params)
  } else {
    return []
  }
}

export function parseFiltersFromQueryParams(queryParams: Map<string, string>): Array<FilterT> {
  return map(Array.from(queryParams.entries()), ([id, value]) => ({
    id,
    value
  }))
}
